import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  connect() {
    console.log("Auto-submit controller connected to:", this.element)
  }

  submit(event) {
    console.log("Submit triggered with value:", event.target.value)
    // Only submit if a valid option is selected (not the prompt)
    if (event.target.value && event.target.value !== "") {
      console.log("Submitting form...")
      this.element.requestSubmit()
    }
  }
}
